import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from '../geo/jurisdiction.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  isAuthenticated : boolean = false;
  clientAppName: string;
  constructor(
    private router: Router,
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private jurisdiction: JurisdictionService,
    private configService: ConfigService
  ){ 

  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const result: boolean = await this.checkUserAuthenticationWithGeo();
    console.log(`can activate route : ${result}`)
    return result;
  }

  checkUserAuthenticationWithGeo(): Promise<boolean> {
    return this.userSessionService.isAuthenticated().then(async isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
      console.log('---user is authenticated---', this.isAuthenticated);
      if (this.isAuthenticated) {
        const geoResult: boolean = await this.checkGeoStatus();
        console.log('--geo--', geoResult)
        return geoResult;
      } else {
        return true;
      }
    });
  }

  checkGeoStatus(): Promise<boolean> {
    return this.jurisdiction.debounceVerifyJurisdiction(() => { }).then((geoResp: GeoResponse) => {
      return Promise.resolve(true);
    }).catch((err) => {
      return Promise.resolve(false);
    });
  }
}
